import { scheduleConsultUrl } from "@/lib/site-core";

export function FinalCta({ variant = "dark" }: { variant?: "dark" | "light" }) {
  const isLight = variant === "light";
  return (
    <section className={`py-10 md:py-12 ${isLight ? "bg-muted" : "bg-foreground"}`}>
      <div className="mx-auto max-w-4xl px-4 text-center lg:px-8">
        <h2 className={`text-3xl font-extrabold leading-tight md:text-4xl ${isLight ? "text-foreground" : "text-background"}`}>
          Ready to Get Your Hair Back?
        </h2>
        <p className={`mx-auto mt-4 max-w-2xl text-base ${isLight ? "text-muted-foreground" : "text-background/80"}`}>
          Schedule your free, no-obligation consultation with the RESTORE® team today.
        </p>
        <a
          href={scheduleConsultUrl}
          className="mt-8 inline-block bg-primary px-8 py-4 text-sm font-bold tracking-wider text-primary-foreground transition hover:bg-primary/90"
        >
          Schedule Your Free Consultation
        </a>
      </div>
    </section>
  );
}